<div class="app-updates">
  <ng-container *ngIf="appUpdatesDTO.featureType === 'optional'">
    <div class="app-updates__title">
      <ion-icon name="notifications-outline"></ion-icon>
      <div class="app-updates__title-text">{{ 'app_updates.update_alert' | translate }}</div>
    </div>
    <div class="app-updates__description">
      <div class="app-updates__des">{{ 'app_updates.update_now_msg' | translate }}</div>
      <div>
        <span class="app-updates__des-bold">{{ 'app_updates.note' | translate }}: </span>
        <span class="app-updates__des">{{ 'app_updates.post_update_log' | translate }}</span>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="appUpdatesDTO.featureType !== 'optional'">
    <div class="app-updates__title">
      <ion-icon name="notifications-outline"></ion-icon>
      <div class="app-updates__title-text">{{ 'app_updates.important_update' | translate }}</div>
    </div>
    <div class="app-updates__description">
      <div class="app-updates__des">{{ 'app_updates.new_update_available' | translate }}</div>
      <div>
        <span class="app-updates__des-bold">{{ 'app_updates.note' | translate }}: </span>
        <span class="app-updates__des">{{ 'app_updates.post_update_log' | translate }}</span>
      </div>
    </div>
  </ng-container>
  <div class="app-updates__actions">
    <ui-custom-button
      class="app-updates__action-margin"
      *ngIf="appUpdatesDTO.featureType === 'optional'"
      [btnTxt]="'app_updates.later' | translate"
      (clickEvent)="updateLater()"
      [buttonType]="'SECONDARY'"
    ></ui-custom-button>
    <ui-custom-button
      [btnTxt]="'app_updates.update_now' | translate"
      (clickEvent)="updateNow()"
    ></ui-custom-button>
  </div>
</div>
